const Services = {
  ServiceDemandes: Symbol.for('ServiceDemandes'),
  ServiceEtudes: Symbol.for('ServiceEtudes'),
  ServiceSessions: Symbol.for('ServiceSessions'),
};

export default Services;
